const MAX_SELECTION = 6;
const HUD_ALERT_DEFAULT_DURATION = 5000;
const MAX_WAVES = 50;
const BOSS_GRACE_DURATION = 15;
const EARLY_EASE_ROUNDS = 10;
const EARLY_EASE_MIN = 0.35;
const EARLY_EASE_STEP = EARLY_EASE_ROUNDS > 1 ? (1 - EARLY_EASE_MIN) / (EARLY_EASE_ROUNDS - 1) : 0;

export {
  MAX_SELECTION,
  HUD_ALERT_DEFAULT_DURATION,
  MAX_WAVES,
  BOSS_GRACE_DURATION,
  EARLY_EASE_ROUNDS,
  EARLY_EASE_MIN,
  EARLY_EASE_STEP,
};
